(function ($) {
    $(function () {
        const desktopLink = $('#desktopLink').val();
        const isExperienceEditor = Boolean($('#isExperienceEditor').val());
        if (!isExperienceEditor) {
            const userAgent = navigator.userAgent;
                window.open(desktopLink, "_self");
        }
    });
})(window.jQuery);
